import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS, computed } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import generalSettings from './GeneralSettings';
import {IconFacebook,IconInstagram} from './Icons';
import FacebookLogin from 'react-facebook-login';

import Settings from './Settings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class SocialPanel  extends Component  {

  @observable trans = { };
  @observable dataReady = false;
  @observable facebookLogin = false;
  @observable instagramLogin = false;

  constructor(props) {

    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    $(window).on('InstagramBridge-setToken',(e,val)=>{
      console.log('val',val);
      let data =  {
        accessToken : val
      }
      Settings.setSettingsSocial('instagram',data,true);
      this.instagramLogin = true;
    });

  }

  responseFacebook = (response) => {
    console.log('responseFacebook',response);
    this.dataReady = true;
    Settings.setSettingsSocial('facebook',response,true);
  }


  responseInstagram = (response) => {
    console.log('responseFacebook',response);
    /*
    this.dataReady = true;
    Settings.setSettingsInstagram(response,true);
    */
  }

  showFacebookLogin(){


    $(window).off('UploadInfo-cancel');
    $(window).on('UploadInfo-cancel',()=>{
      $(window).off('UploadInfo-accepted');
      $(window).off('UploadInfo-cancel');
    });

    $(window).off('UploadInfo-accepted');
    $(window).on('UploadInfo-accepted',()=>{
      this.facebookLogin = true;
      $(window).off('UploadInfo-accepted');
    });

    if ( Settings.getSettingsMediaListCount < 1 )
    //if( ($('#bf-media-gallery.js-bf-media:first li').length < 1 ) )
    {
      Settings.setFirstUpload(true,false);

    }
    else
    {
      Settings.setFirstUpload(false);
    }

    if ( Settings.getSettingsFirstUploadAccepted || !Settings.getSettingsFirstUpload )
    {
      if ( Settings.getSettingsMediaListCount > 19 ) {
        var obj = new Object();
        obj.title = "Information";
        obj.text = 'You can have only 20 images in Your media area.';
        obj.type = 'warning';
        $(window).trigger('notify', obj);
      }
      else {
        this.facebookLogin = true;
      }
    }


  }

  instagramPopupLogin(){
    //'https://www.instagram.com/accounts/login/?force_classic_login=&next=/oauth/authorize/?client_id=97ce02fbc2394200817a445dde262285&response_type=token&redirect_uri=https://demo.getprintbox.com/hello?content_only=1&state={"client_id":"97ce02fbc2394200817a445dde262285","network":"instagram","display":"popup","callback":"_hellojs_5sl5q3cm","state":"","redirect_uri":"https://demo.getprintbox.com/hello?content_only=1","scope":"basic,basic public_content"}&scope=basic basic public_content'
    console.log('https://www.instagram.com/accounts/login/?force_classic_login=&next=/oauth/authorize/?client_id='+Settings.getSettingsSocialApiToken('instagram')+'&response_type=token&redirect_uri=http://localhost/print-creator/instagram.php&scope=basic basic public_content');
    //window.open('https://www.instagram.com/accounts/login/?force_classic_login=&next=/oauth/authorize/?client_id='+Settings.getSettingsSocialApiToken('instagram')+'&response_type=code&redirect_uri=http://localhost/print-creator/instagram.php&scope=basic basic public_content','',320,320)
    window.open('https://www.instagram.com/oauth/authorize/?client_id=a26fa6c0b7c149b48e4786477963a25d&response_type=token&redirect_uri=http://localhost/print-creator/instagram.php?content_only=1','Login',500,500);
  }

  render() {

    const t = this.t;

    return (
      <div className="SocialPanel">
        <span>{t('Socials')}</span>
        {
          ( generalSettings.getSettings.facebookPageUrl && false )
          &&
          <span><a target="_blank" href={generalSettings.getSettings.facebookPageUrl}><IconFacebook/></a></span>
        }
        {
          ( generalSettings.getSettings.facebookPageUrl   )
          &&
          <span>
            {
              !this.facebookLogin
                ?
                <a onClick={()=>{this.showFacebookLogin()}}><IconFacebook/></a>
                :
                <a>
                  <FacebookLogin
                    appId={Settings.getSettingsSocialApiToken('facebook')}
                    autoLoad={true}
                    fields="name,email,picture,albums,photos"
                    scope="user_photos"
                    callback={(response)=>{ this.responseFacebook(response) } } >  <IconFacebook/> </FacebookLogin>
                </a>
            }

          </span>
        }
        {
          generalSettings.getSettings.instagramPageUrl
          &&
          <span>
            {
              true &&
              <a target="_blank" href={generalSettings.getSettings.instagramPageUrl}><IconInstagram/></a>
            }
            {
              false &&
              <a onClick={()=>{ this.instagramPopupLogin() }} ><IconInstagram/></a>
            }

          </span>
        }
      </div>
    );
  }
}

/*

 <InstagramLogin
 clientId={Settings.getSettingsSocialApiToken('instagram')}
 buttonText="Test"
 onSuccess={ (response)=>{ this.responseInstagram(response) } }
 onFailure={ (response)=>{ this.responseInstagram(response) } }
 />
 */

